//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { OpDescr } from './op-descr'

export class OpIssueType implements IReferenceType, IOpChangeState, IJsonSerializable {
    public idIssueType: number
    public description: string
    public idDescr: number
    public descr: OpDescr

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdIssueType
    }
    public getReferenceKey(): number {
        return this.idIssueType
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end

    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || (opObj && opObj.__IC && opObj.__IC == 1)) {
                this.idIssueType = opObj.IT
                this.description = opObj.DE
                this.idDescr = opObj.I
                this.descr = opObj.D ? new OpDescr(opObj.D) : null
                this.opState = opObj.O
            } else {
                this.idIssueType = opObj.ID_ISSUE_TYPE
                this.description = opObj.DESCRIPTION
                this.idDescr = opObj.ID_DESCR
                this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
                this.opState = opObj.OpState
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            return {
                IT: this.idIssueType,
                DE: this.description,
                I: this.idDescr,
                D: this.descr ? this.descr.toJSON(compressed) : null,
                O: this.opState,
                __IC: 1
            }
        } else {
            return {
                ID_ISSUE_TYPE: this.idIssueType,
                DESCRIPTION: this.description,
                ID_DESCR: this.idDescr,
                _Descr: this.descr ? this.descr.toJSON(compressed) : null,
                OpState: this.opState
            }
        }
    }
    
    public toString(): string {
        if (this.descr)
            return this.descr.description
        else
            return this.description
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpIssueType[]): JQueryPromise<OpIssueType[]> {
        var defered = $.Deferred<OpIssueType[]>()

        defered.resolve(list)

        return defered.promise()
    }

}